/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowDownFromLine: {
  name: 'arrow-down-from-line';
  data: string;
} = {
  name: 'arrow-down-from-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 1.5H3a.5.5 0 0 1 0-1h10a.5.5 0 0 1 0 1H8.5v12.293l4.146-4.147a.5.5 0 0 1 .708.708l-5 5a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.708L7.5 13.793V1.5Z" fill="currentColor"/></svg>`,
};
